import React, { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { collectCitations, evidenceSummaryLine } from './boardScreenHelpers';
import { describeEvidenceRow } from './evidenceHelpers';

function ExpandableBody({ body, rowKey }) {
  const [expanded, setExpanded] = useState(false);
  if (!body) return null;
  const needsExpand = body.length > 120 || body.split('\n').length > 2;
  return (
    <>
      <p className={`ev-body${expanded ? '' : ' ev-body--clamp'}`}>{body}</p>
      {needsExpand && (
        <button
          type="button"
          className="bp-inline-link"
          onClick={() => setExpanded((v) => !v)}
        >
          {expanded ? 'Collapse' : 'Expand'}
        </button>
      )}
    </>
  );
}

export default function EvidenceList({
  citations,
  evidence = {},
  findingsById = {},
  expectationsByKey = {},
  onSelectFinding,
  onSelectBridge,
  compact = false
}) {
  const [open, setOpen] = useState(false);
  const groups = collectCitations(citations || {});
  if (!groups.length) return <small className="bp-muted">No evidence recorded.</small>;
  const summary = evidenceSummaryLine(citations || {});
  const ctx = { evidence, findingsById, expectationsByKey };

  return (
    <div className={`ev-list${compact ? ' ev-list--compact' : ''}`}>
      <button
        type="button"
        className="ev-summary"
        onClick={() => setOpen((value) => !value)}
        aria-expanded={open}
      >
        {open ? <ChevronDown size={12} /> : <ChevronRight size={12} />}
        <span className="ev-summary-text">EVIDENCE · {summary}</span>
      </button>
      {open && (
        <ul className="ev-rows">
          {groups.flatMap(({ type, ids }) =>
            ids.map((id) => {
              const row = describeEvidenceRow(type, id, ctx);
              const key = `${type}-${id}`;

              if (row.header) {
                return (
                  <li key={key} className="ev-row ev-row--stacked">
                    <span className="ev-type">{type}</span>
                    <div className="ev-stack">
                      <div className="ev-header">
                        <span>{row.header}</span>
                        {row.finding && onSelectFinding && (
                          <button
                            type="button"
                            className="bp-inline-link"
                            onClick={() => onSelectFinding(row.finding)}
                          >
                            Workbench →
                          </button>
                        )}
                      </div>
                      <ExpandableBody body={row.body} rowKey={key} />
                    </div>
                  </li>
                );
              }

              const onClick =
                row.finding && onSelectFinding
                  ? () => onSelectFinding(row.finding)
                  : row.bridgeInfo && onSelectBridge
                    ? () => onSelectBridge(row.bridgeInfo)
                    : row.onClick;

              return (
                <li key={key} className="ev-row">
                  <span className="ev-type">{type}</span>
                  {onClick ? (
                    <button type="button" className="bp-inline-link" onClick={onClick}>
                      {row.label}
                    </button>
                  ) : (
                    <span>{row.label}</span>
                  )}
                  {row.detail && <span className="bp-mono ev-detail">{row.detail}</span>}
                </li>
              );
            })
          )}
        </ul>
      )}
    </div>
  );
}
